import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable, EventEmitter, Output } from '@angular/core';
import { AuthService } from './auth.service';
import { AppData } from '../../ncs/models/appdata';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private authService: AuthService) { }

  @Output() authChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  private userAuthChanged(status: boolean) {
    this.authChanged.emit(status); //Raise changed event
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    //return this.authService.isAuthenticated();
    //if ((AppData.Instance().UserLoginDetails == null || AppData.Instance().UserLoginDetails.UserName == null) ||
    //  AppData.Instance().UserLoginDetails.AuthGenKEY == null || (localStorage.length <= 0))

    if ((AppData.Instance().UserLoginDetails == null || AppData.Instance().UserLoginDetails.UserName == null)
      || AppData.Instance().UserLoginDetails.AuthGenKEY == null || (localStorage.length <= 0)
      || AppData.Instance().IsSessionExits == null || AppData.Instance().IsSessionExits === false
      || (AppData.Instance().UserLoginDetails.UserName != localStorage.getItem("UserName")))
    {
      console.log('AuthGuard Expired');
     
      this.router.navigate(['signinpage']);
      return false;
    }

    else {
      if (localStorage.getItem('UserName')) {
        this.userAuthChanged(true);
      //  console.log('AuthGuard..' + localStorage.getItem('UserName'));
        return true;
      }
      else {
      //  console.log('AuthGuard Expired..' + localStorage.getItem('UserName'));
        this.router.navigate(['signinpage']);
        return false
      }
    }

  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    return true;
  } 
}
